import React from "react";
import "./footer.css";
import { Col, Row } from "antd";

function Footer() {
  return (
    <div className="footerbck">
      <Row>
        <Col span={8}>
          <div className="imgppp">
            <img className="lllllgooo" src="images/logo.png" alt="exmple"></img>
            <p className="ppp">
              NLSA <br />
            </p>
          </div>
          <div className="llgooo">
            <a href="https://www.facebook.com/NLSA112">
              <img className="llllgggggg" src="fb.png" alt="ggg"></img>
            </a>
            <a>
              <img className="llllgggggg" src="twitter.png" alt="ggg"></img>
            </a>
            <a href="https://www.youtube.com/@newlahorescienceacademy3229">
              <img className="llllgggggg" src="youtube.png" alt="ggg"></img>
            </a>
            <a href="https://wa.me/03084042712">
              <img className="llllgggggg" src="whatsapp.png" alt="ggg"></img>
            </a>
          </div>
        </Col>
        <Col span={8} className="quickppp">
          <p className="qppp">Quick Links</p>
          <p className="qppp1"> Home </p>
          <p className="qppp1"> Lims </p>
          <p className="qppp1"> Short Courses </p>
          <p className="qppp1"> Contact Us </p>
        </Col>
        <Col span={8} className="quickppp">
          {" "}
          <p className="qppp">NLSA Projects</p>
          <p className="qppp1"> Lims </p>
          <p className="qppp1"> Short Courses </p>
          <br />
          <p className="qppp1" style={{ fontWeight: "bold" }}>
            {" "}
            +92 308 4042712{" "}
          </p>
          <p className="qppp1" style={{ fontWeight: "bold" }}>
            {" "}
            Address: Naya pull chaman park near jutt store LHR{" "}
          </p>
        </Col>
      </Row>
      <Col>
        <p className="uhyvgv">
          © Copyrights 2022 design by New Lahore Science Academy
        </p>
      </Col>
    </div>
  );
}

export default Footer;
